module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 0
// module chunks = 0 1 2 3 4 5 6 7 8